import { useEffect } from 'react';
import { LocalTournament } from 'react-easyrocket';
import { CUSTOM_EVENTS } from 'src/modules/localTournamentNotification/storageApi/constants';
import { TournamentEvents } from 'src/modules/localTournamentNotification/types';
import { useNotifiacationLocalTournamentStore } from 'src/store';
import { onCustomEvent } from 'src/utils/onCustomEvent';

interface NewTournamentNotificationReturnTypes {
  newTournament: LocalTournament | null;
  setNewTournament: (state: LocalTournament | null) => void;
}

export const useNewTournamentNotification = (): NewTournamentNotificationReturnTypes => {
  const { newTournament, setNewTournament } = useNotifiacationLocalTournamentStore();

  useEffect(() => {
    return onCustomEvent<TournamentEvents, typeof CUSTOM_EVENTS.NEW_LOCAL_TOURNAMENT>(
      window,
      CUSTOM_EVENTS.NEW_LOCAL_TOURNAMENT,
      (e) => {
        setNewTournament(e.detail.newTournament);
      },
      { passive: true }
    );
  }, []);

  useEffect(() => {
    return onCustomEvent<TournamentEvents, typeof CUSTOM_EVENTS.RESET_NEW_LOCAL_TOURNAMENT>(
      window,
      CUSTOM_EVENTS.RESET_NEW_LOCAL_TOURNAMENT,
      () => {
        setNewTournament(null);
      },
      { passive: true }
    );
  }, []);

  return { newTournament, setNewTournament };
};
